<template>
  <div class="preview-video-viewer" :class="{showing: visible}">
    <video autoplay muted loop ref="media">
      <source :src="src" type="video/mp4" />
    </video>
  </div>
</template>

<script>
export default {
  props:{
    src: String,
  },
  data () {
    return {
      visible: false
    }
  },
  mounted () {
    this.mountMedia()
  },
  methods: {
    mountMedia () {
      this.media = this.$refs.media
      if(this.media) {
        this.media.addEventListener('canplay', this.checkPlay)
      }
      
    },
    checkPlay () {
      this.visible = true
      this.media.removeEventListener('canplay', this.checkPlay)
      this.$emit('load', { width: this.$el.offsetWidth, height: this.$el.offsetHeight })
      this.media.play()
    }
    
  },
  watch: {
    src () {
      this.mountMedia()
    }
  }
}
</script>

<style scoped>
  .preview-video-viewer{
    position:absolute;
    background-color:#fff;
    top:0;
    left:0;
    width:100%;
    height:0;
    padding-bottom:56.25%;
    overflow:hidden;
    pointer-events: none;
    user-select: none;
    z-index:30;
    opacity:0;
  }

  .preview-video-viewer.showing{
    opacity:1;
  }

  .preview-video-viewer video{
    position:absolute;
    top:0;
    left:0;
    width:100%;
    height:100%;
  }




</style>
